module.exports = __webpack_public_path__ + "static/media/optometryOffices.eae3034b.jpg";